import { fetch as fetch$1 } from 'cross-fetch';

/// <reference lib="dom" />
// This is useful for mocking fetch in tests.
const fetch = fetch$1;

export { fetch };
//# sourceMappingURL=universal.mjs.map
